module.exports = __webpack_public_path__ + "media/icons/key-f-99377802.svg";